import dayjs from 'dayjs'

export function RawTimeToTime (rawTime, options) {
  const isGivenTime = rawTime.indexOf('/') > -1

  const typeParts = rawTime.split('/')
  const type = typeParts[1]
  const rawParts = typeParts[0]

  const addBase = rawParts.substring(3, 4)
  const base = addBase === '+' ? 1 : addBase === '-' ? -1 : 0
  const num = parseInt(rawParts.substring(4))
  const unit = rawParts.substring(4).replace(num, '')

  let time = base === 0 ? dayjs() : dayjs().add(base * num, unit)
  if (isGivenTime) {
    const simpleNames = {
      d: 'date',
      w: 'week',
      y: 'year',
      M: 'month',
      h: 'hour'
    }
    if (options.end === 'from') {
      time = time.startOf(simpleNames[type])
    } else {
      time = time.endOf(simpleNames[type])
    }
  }

  time = dayjs(Math.min(time.valueOf(), dayjs().valueOf()))
  if (options.format) {
    return time.format(options.format)
  } else {
    return time.valueOf()
  }
}
